import { Button, Input } from "@/atoms";
import { GradientBackground } from "@/components";
import { strings } from "@/constants";
import { GradientVariantEnum, InputTypeEnum } from "@/enums";

export const ResultLoadingState = ({
    code,
    onReset,
}: {
    code: string,
    onReset: () => void,
}) => (
    <>
        <GradientBackground variant={GradientVariantEnum.LOADING} />
        <div
            className="
                w-full
                max-w-2xl
                px-4
                text-center
                sm:px-8
            "
        >
            <h1
                className="
                    text-gradient
                    mb-2
                    text-2xl
                    font-bold
                    sm:text-3xl
                "
            >
                {strings.benchmark.titleLoading}
            </h1>
            <div className="mb-8">
                <div
                    className="
                        inline-block
                        h-8
                        w-8
                        animate-spin
                        rounded-full
                        border-4
                        border-primary
                        border-t-transparent
                    "
                />
            </div>
            <div
                className="
                    flex
                    flex-col
                    items-center
                    justify-center
                    gap-4
                    sm:flex-row
                "
            >
                <div className="w-full max-w-md sm:flex-1">
                    <Input
                        type={InputTypeEnum.TEXT}
                        value={code}
                        disabled
                    />
                </div>
                <Button onClick={onReset}>{strings.result.buttonReset}</Button>
            </div>
        </div>
    </>
);
